import { useState } from "react";
import { styled } from '@mui/material/styles';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { AccordionSummary } from "@mui/material";
import HTMLReactParser from "html-react-parser";

interface IProps {
    children: React.ReactNode,
    header?: string,
    color?: string,
    expandIconColor?: string,
    bgColor?: string,
    background?: string,
    borderColor?: string
    isExpanded?: boolean
    borderRadius?: string,
    boxShadowHead?: string,
    boxShadowDetail?: string,
}

const AccordionCustom: React.FC<IProps> = ({ children, header, color, expandIconColor, bgColor, background, borderColor, isExpanded, borderRadius, boxShadowHead, boxShadowDetail }) => {
    const [expanded, setExpanded] = useState(isExpanded ?? true);

    const handleChange = () => {
        setExpanded(!expanded);
    };

    const AccordionStyled = styled((props: AccordionProps) => (
        <MuiAccordion disableGutters elevation={0} {...props} />
    ))(() => ({
        border: "1px solid #99410287",
        borderRadius: borderRadius ?? '9px !important',
    }));

    const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
        padding: theme.spacing(2),
    }));

    return (
        <AccordionStyled expanded={expanded} sx={{ border: borderColor }}>
            <AccordionSummary
                onClick={handleChange}
                expandIcon={<ArrowDropDownIcon style={{ fontSize: '2.5rem', color: expandIconColor ?? "#ffffff" }} />}
                sx={{
                    zIndex: 'auto',
                    color: color ?? "#ffffff",
                    backgroundColor: bgColor ?? "#5a4011",
                    background: background ?? "#5a4011",
                    cursor: 'pointer',
                    borderRadius: borderRadius ?? "6px",
                    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                        transform: 'rotate(180deg)',
                    },
                    '& .MuiAccordionSummary-content': {
                        marginLeft: '8px',
                    },
                    alignItems: "center",
                    '& .MuiAccordionSummary-expandIconWrapper': {
                        margin: "0"
                    },
                    boxShadow: boxShadowHead ?? "none",
                }}
            >
                <Typography className="font-medium">{HTMLReactParser(header)}</Typography>
            </AccordionSummary>
            <AccordionDetails sx={{
                boxShadow: boxShadowDetail ?? "none",
                borderRadius: borderRadius ?? "0px"
            }}>
                {children}
            </AccordionDetails>
        </AccordionStyled>
    )
}

export default AccordionCustom